module.exports = __webpack_public_path__ + "docs/guide_sell.pdf";